import styled from '../../../styled';
import { Alert } from '@digdir/designsystemet-react';

export const SidebarPageLayout = styled.div`
  display: grid;
  grid-template-areas:
    'breadcrumbs breadcrumbs'
    'sidebar mainContent';
  grid-template-columns: var(--sidebar-width) var(--content-width);

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-template-areas:
      'breadcrumbs'
      'sidebar'
      'mainContent';
    grid-template-columns: 1fr;
    margin: 0 var(--ds-size-4);
  }
`;

export const PageLayout = styled.div`
  display: grid;
  grid-template-areas:
    'breadcrumbs'
    'mainContent';
  grid-template-columns: var(--content-width);

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.values.md}px) {
    grid-template-columns: 1fr;
  }
`;

export const BreadcrumbsWrapper = styled.div`
  grid-area: breadcrumbs;
  margin: var(--ds-size-8) 0;
  a:visited {
    color: var(--ds-color-text-subtle);
  }

  a:hover {
    text-decoration: none;
  }
`;

export const SidebarWrapper = styled.div`
  grid-area: sidebar;
  margin-right: var(--ds-size-8);
`;

export const MainContentWrapper = styled.div`
  grid-area: mainContent;
  max-width: var(--content-width);
  width: 100%;
  margin-bottom: var(--ds-size-8);
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-8);
`;

export const DetailedAlert = styled(Alert)`
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
`;
